export class Result {
    value;
    success;
    message;
    code;

    constructor(data) {
        let { value, message, code } = data;
        this.value = value??null;
        this.code = code??null;
        this.message = message??null;
        //do not treat a 0 value as a failed result
        if (value == null || value == undefined) {
            this.success = false;
        } else {
            this.success = true
        }
    }
}

export const MessageCodes = {
    NO_PRIVILEGE: 403,
}